import { Box, BoxProps } from "@mantine/core";

export function EarlyAccessBadge(props: BoxProps) {
  return (
    <Box
      bg="gray.2"
      c="gray.5"
      display="inline-block"
      fz="xs"
      lh="16px"
      px="xs"
      py={4}
      style={{ borderRadius: "0.25rem", whiteSpace: "nowrap" }}
      {...props}
    >
      Early access
    </Box>
  );
}
